module.exports = __webpack_public_path__ + "static/dsa-advanced-course-f1061ac84b326f1a85042a8f4ca61452.png";